import { isNetworkError, nativeErrorData } from "./networkError";

// @capacitor/file-transfer's generic error; on iOS it wraps every URLError
// other than "not connected" and "timed out" (connection lost, cancelled, ...).
const FILE_TRANSFER_GENERIC_ERROR = "OS-PLUG-FLTR-0011";
// @capacitor/file-transfer's "server answered with an HTTP error".
const FILE_TRANSFER_HTTP_ERROR = "OS-PLUG-FLTR-0010";

const errorCode = (e: unknown): unknown =>
  e !== null && typeof e === "object"
    ? (e as Record<string, unknown>).code
    : undefined;

/**
 * S3 rejecting the presigned upload URL. In practice that's the URL having
 * expired (S3 answers "Request has expired") because the app was suspended
 * between getting the URL and the transfer running. iOS doesn't pass the
 * response body on, so any 403 counts: a retry gets a fresh URL, and a 403
 * that persists with a fresh one is still reported.
 */
const isRejectedUploadUrl = (e: unknown): boolean =>
  errorCode(e) === FILE_TRANSFER_HTTP_ERROR &&
  nativeErrorData(e)?.httpStatus === 403;

/**
 * Whether a failed S3 upload from the native app is worth one more attempt
 * (with a fresh presigned URL) once the app is back in the foreground.
 */
export const isRetryableUploadError = (e: unknown): boolean =>
  isNetworkError(e) ||
  errorCode(e) === FILE_TRANSFER_GENERIC_ERROR ||
  isRejectedUploadUrl(e);
